module.exports = __webpack_public_path__ + "static/media/book-user.9cd6b85f.svg";